<template>
  <div class="image-ad_hot-area-image" :style="style">
    <div class="image-wrap"
         v-for="item in config.sub_entry"
         :style="itemStyle"
         :key="item.key">
      <van-image :src="item.image_url"/>
      <component :is="tagName" class="hot-area"
                 :href="area.link_url"
                 v-for="area in item.hot_areas"
                 :key="area.key"
                 :style="getAreaStyle(item, area)"
      ></component>
      <div class="link-title" v-if="item.title">{{item.title}}</div>
    </div>
  </div>
</template>

<script>
  const WIDTH = process.env.NODE_ENV === "production" ? document.documentElement.clientWidth : 375;
  export default {
	name: "HotAreaImage",
	components: {},
	props: {
	  config: Object
	},
	data() {
	  return {};
	},
	methods: {
	  getAreaStyle(item, {start_x, start_y, end_x, end_y}) {
		const {image_width, image_height} = item;
		const imageHeight = (image_height / image_width) * this.width;

		return {
		  top: start_y * imageHeight + "px",
		  left: start_x * this.width + "px",
		  width: (end_x - start_x) * this.width + "px",
		  height: (end_y - start_y) * imageHeight + "px"
		};
	  }
	},
	computed: {
	  tagName() {
		return this.$IS_PREVIEW ? 'div' : 'a';
	  },
	  style() {
		if (this.config.sub_entry.length) return {marginBottom: -this.config.image_margin + "px"};
		return "";
	  },
	  itemStyle() {
		return {
		  borderRadius: this.config.corner_type ? "10px" : "",
		  boxShadow: this.config.image_style ? "0 4px 10px rgba(47,54,70,0.1)" : "",
		  marginBottom: this.config.image_margin + "px"
		};
	  },
	  width() {
		return WIDTH - this.config.page_margin;
	  }
	}

  };
</script>

<style lang="less" rel="stylesheet/less">

  .image-ad_hot-area-image {
    position: relative;

    .image-wrap {
      position: relative;
      overflow: hidden;

      .van-image {
        display: block;
      }
    }

    .hot-area {
      position: absolute;
    }
  }
</style>
